<!--Banner-->
<div class="d-lg-block d-none mb-4">
  <fgb-banner title="{{ name$ | async }}"></fgb-banner>
</div>

<fgb-mobile-page-header
  pageTitle="account.page.title"
  [showFooter]="true"
  [showQr]="true"
  [backButtonLink]="'/'"
></fgb-mobile-page-header>
<fgb-account-nav></fgb-account-nav>

<div class="container">
  <div class="row">
    <div class="d-none d-lg-block col-lg-6">
      <h5 class="mb-2 mt-0" [ngClass]="isCorporate ? 'corporate-font' : 'default-font'">
        {{ 'account.member.card.title' | translate }}
      </h5>
      <fgb-member-card></fgb-member-card>
    </div>
    <div class="col-12 col-lg-6">
      <h5 class="mb-2 mt-0" [ngClass]="isCorporate ? 'corporate-font' : 'default-font'">
        {{ 'account.member.detail.title' | translate }}
      </h5>
      <fgb-account-details></fgb-account-details>
      <div class="mt-4">
        <fgb-fitness-tracker-card></fgb-fitness-tracker-card>
      </div>
    </div>
  </div>
</div>
